<template>
    <div
        class="Popup"
        :style="popupStyle"
    >
        <ul
            v-for="(itemsGroup, groupIndex) in splittedItems"
            :key="`group_${groupIndex}`"
            class="Properties"
        >
            <li
                v-for="(item, index) in itemsGroup"
                :key="`item_${index}`"
                class="Property"
            >
                <WText
                    class="Label"
                    color="accent-blue"
                    weight="bold"
                >
                    {{ item.label }}:
                </WText>
                <div
                    v-if="checkMultipleValue(item)"
                    class="MultipleValue"
                >
                    <WText
                        v-for="(value, valueIndex) in item.value"
                        :key="`value_${valueIndex}`"
                    >
                        {{ value }}<span v-if="valueIndex + 1 < item.value.length">,</span>
                    </WText>
                </div>
                <WText
                    v-else
                    class="Value"
                >
                    {{ item.value }}
                </WText>
            </li>
        </ul>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { cursorAxisMixin } from '@/mixins'

export default {
    name: 'RowPopup',
    mixins: [cursorAxisMixin],
    props: {
        visible: VueTypes.bool,
        items: VueTypes.array,
    },
    computed: {
        popupStyle () {
            const { innerWidth, innerHeight } = window
            const { visible, cursorAxis } = this
            const openLeft = cursorAxis.x > (innerWidth / 2)
            const openTop = cursorAxis.y > (innerHeight / 2)
            return {
                opacity: visible ? 1 : 0,
                ...(openLeft ? { right: `${innerWidth - cursorAxis.x}px` } : { left: `${cursorAxis.x}px` }),
                ...(openTop ? { bottom: `${innerHeight - cursorAxis.y}px` } : { top: `${cursorAxis.y}px` }),
            }
        },
        splittedItems () {
            const { items } = this
            const half = Math.ceil(items.length / 2)
            return [items.slice(0, half), items.slice(half, items.length)]
        },
    },
    methods: {
        checkMultipleValue ({ value }) {
            return Array.isArray(value)
        },
    },
}
</script>

<style lang="scss" scoped>
.Popup {
    display: flex;
    flex-direction: row;
    gap: 20px;
    position: absolute;
    z-index: 1000;
    background-color: white;
    border: 1px solid $gray-04;
    padding: 20px;
    margin: 10px;
    transition: opacity 0.2s;
    border-radius: $border-radius;
    box-shadow: $ag-card-shadow;
    max-width: 500px;
    .Properties {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
        gap: 10px;
        .Property {
            display: flex;
            flex-direction: column;
            .MultipleValue {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 4px;
            }
        }
    }
}
</style>
